export const ROLE_INVESTOR = 'investor';
export const ROLE_BORROWER = 'borrower';

export const APPLICATION_STATUSES = [
  {
    id: 'new',
    name: 'На модерации',
    applicationName: 'Новая заявка',
    editable: true,
    canBeFavorite: false,
    color: '#9B9B9B'
  },
  {
    id: 'edit',
    name: 'Редактируется',
    applicationName: 'Редактирование заявки',
    editable: true,
    canBeFavorite: false,
    color: '#9B9B9B'
  },
  {
    id: 'moderate wait',
    name: 'На модерации',
    applicationName: 'Просмотр заявки',
    editable: false,
    canBeFavorite: false,
    color: '#9B9B9B'
  },
  {
    id: 'moderation',
    name: 'На модерации',
    applicationName: 'Просмотр заявки',
    editable: false,
    canBeFavorite: false,
    color: '#9B9B9B'
  },
  {
    id: 'canceled',
    name: 'Отклонена',
    applicationName: 'Редактирование заявки',
    editable: true,
    canBeFavorite: false,
    color: '#FC7575'
  },
  {
    id: 'declined',
    name: 'Отклонена',
    applicationName: 'Редактирование заявки',
    editable: true,
    canBeFavorite: false,
    color: '#FC7575'
  },
  {
    id: 'deleted',
    name: 'Удалена',
    applicationName: 'Редактирование заявки',
    editable: true,
    canBeFavorite: false,
    color: '#EB5757'
  },
  {
    id: 'approved',
    name: 'Ожидание начала раунда',
    applicationName: 'Просмотр заявки',
    editable: false,
    canBeFavorite: true,
    color: `#9B9B9B`
  },
  {
    id: 'accepted',
    name: 'Подтверждена',
    applicationName: 'Просмотр заявки',
    editable: false,
    canBeFavorite: true,
    color: `#2D6ECF`
  },
  {
    id: 'loan_agreement',
    name: 'Сбор завершён',
    applicationName: 'Просмотр заявки',
    editable: false,
    canBeFavorite: false,
    color: '#2C1249'
  },
  {
    id: 'fulfilled',
    name: 'Займ погашен',
    applicationName: 'Просмотр заявки',
    editable: false,
    canBeFavorite: false,
    color: '#2C1249'
  },
  {
    id: 'archive',
    name: 'В архиве',
    applicationName: 'Редактирование заявки',
    editable: true,
    canBeFavorite: false,
    color: '#EB5757'
  },
  {
    id: 'sms_verify',
    name: 'Раунд финансирования. Ожидание подтверждения sms кода.',
    applicationName: 'Просмотр заявки',
    editable: false,
    canBeFavorite: true,
    color: `#448EDE`
  },
  {
    id: 'finance_round_time',
    name: 'Сбор завершён',
    applicationName: 'Просмотр заявки',
    editable: false,
    canBeFavorite: true,
    color: '#2C1249'
  },
  {
    id: 'finance_round',
    name: 'Раунд финансирования',
    applicationName: 'Просмотр заявки',
    editable: false,
    canBeFavorite: true,
    color: '#FC7575'
  },
  {
    id: 'cancel_round',
    name: 'Отмена сделки',
    applicationName: 'Просмотр заявки',
    editable: false,
    canBeFavorite: false
  },
  {
    id: 'complete',
    name: 'Завершена',
    applicationName: 'Просмотр заявки',
    editable: false,
    canBeFavorite: false,
    color: '#23A566'
  },
];

export const LOAN_PURPOSES = [
  {
    id: 'current_assets',
    name: 'Оборотные средства',
    isOther: false
  },
  {
    id: 'purchase_of_equipment',
    name: 'Приобретение оборудования',
    isOther: false
  },
  {
    id: 'repayment_of_existing_obligations',
    name: 'Погашение имеющихся обязательств',
    isOther: false
  },
  {
    id: 'payment_for_specialist_services',
    name: 'Оплата услуг специалистов',
    isOther: false
  },
  {
    id: 'content_purchase',
    name: 'Покупка контента',
    isOther: false
  },
  {
    id: 'production_of_content',
    name: 'Производство конента (видеосъемка, звукозапись)',
    isOther: false
  },
  {
    id: 'content_promotion',
    name: 'Продвижение контента',
    isOther: false
  },
  {
    id: 'event_organisation',
    name: 'Организация мероприятия (концерта, акции)',
    isOther: false
  },
  {
    id: 'other',
    name: 'Иное',
    isOther: true
  },
];

export const APPLICATION_REPAYMENT_ORDERS = [
  {
    id: 'single_payment',
    name: 'Единым платежом'
  },
  {
    id: 'equal_payments',
    name: 'Аннуитетные платежи'
  },
];

export const APPLICATION_VISIBILITY = [
  {
    id: 'show_everyone',
    name: 'Показать всем'
  },
  {
    id: 'only_registered_users',
    name: 'Только зарегистрированным пользователям'
  }
]

export const OIS_TYPES = {
    MUSIC_COMPOSITION_WITH_TEXT: 'music_composition_with_text',
    MUSIC_COMPOSITION_WITHOUT_TEXT: 'music_composition_without_text',
    MUSIC_PERFOMANCE: 'music_performance',
    MUSIC_PHONOGRAM: 'music_phonogram',
    VIDEO: 'video'
}

export const OIS_TYPES_RU = {
    [OIS_TYPES.MUSIC_COMPOSITION_WITH_TEXT]: 'Музыкальное произведение с текстом',
    [OIS_TYPES.MUSIC_COMPOSITION_WITHOUT_TEXT]: 'Музыкальное произведение без текста',
    [OIS_TYPES.MUSIC_PERFOMANCE]: 'Исполнение',
    [OIS_TYPES.MUSIC_PHONOGRAM]: 'Фонограмма',
    [OIS_TYPES.VIDEO]: 'Видео'
};

export const PROFILE_STATUSES = {
    set_status: 'Проверяется',
    archived: 'Архивный',
    verified: 'Проверен',
    checked: 'Проверяется',
    rejected: 'Заблокирован',
    identified: 'Подтвержден',
    banned: 'Заблокирован',
    inactive: 'Неактивный',
    refused: 'Отказ'
}

export const ORDER_SCHEDULE_COLUMNS_STATS = [
  {
      alias: 'number',
      style: 'width: 4%',
      name: '№ п/п',
      isHeader: true,
  },
  {
      alias: 'date',
      style: 'width: 8%',
      name: 'Дата платежа',
      isHeader: true,
  },
  {
      alias: 'payingTotal',
      style: 'width: 9%',
      name: 'Тело займа',
  },
  {
      alias: 'percent',
      style: 'width: 9%',
      name: 'Проценты',
  },
  {
      alias: 'paying',
      style: 'width: 10%',
      name: 'Итого',
  },
  {
      alias: 'remains',
      style: 'width: 12%',
      isHeader: true,
      name: 'Остаток задолженности,\xA0₽',
  },
  // {
  //   alias: 'ndfl',
  //   style: 'width: 14%',
  //   className: 'align_right',
  //   name: 'НДФЛ к удержанию\n и уплате в ИФНС,\xA0₽'
  // },
]

export const ORDER_SCHEDULE_COLUMNS_STATS_SECOND = [
  {
      alias: 'number',
      style: 'width: 4%',
      name: '№ п/п',
      rowspan: '2'
  },
  {
      alias: 'date',
      style: 'width: 8%',
      name: 'Дата платежа',
      rowspan: '2'
  }
]